<template>
  <generic-update-list
    v-bind="{ model, modelHeaders, modelFk, defaultItem, filters }"
    custom-export-url="/bookings/export/"
  >
    <template v-slot:form="{ editedItem, error }">
      <booking-form v-bind="{ editedItem, error, modelFk }"></booking-form>
    </template>

    <template v-slot:item.start_date="{ item }">
      {{ formatDate(item.start_date) }}
    </template>

    <template v-slot:item.end_date="{ item }">
      {{ formatDate(item.end_date) }}
    </template>

    <template v-slot:item.status="{ item }">
      <booking-status-indicator small :status="item.status" />
    </template>

    <template v-slot:item.warnings="{ item }">
      <v-icon v-if="item.warnings.length > 0">
        fa fa-exclamation-triangle
      </v-icon>
    </template>
  </generic-update-list>
</template>

<script>
import models from "@/models"
import BookingForm from "@/components/BookingForm"
import BookingStatusIndicator from '@/components/BookingStatusIndicator.vue'; // Adjust the path as necessary

export default {
  components: {
    BookingStatusIndicator,
    BookingForm
  },
  data() {
    return {
      modelHeaders: [
        { text: "Artisti", value: "booking__people" },
        { text: "Stanza", value: "booking__room__name" },
        { text: "Hotel", value: "booking__hotel__name" },
        { text: "Data inizio", value: "start_date" },
        { text: "Data fine", value: "end_date" },
        { text: "Ospiti", value: "guests_total" },
        { text: "Stato", value: "status" },
        { text: "Alert", value: "warnings" },
      ],
      model: models.Booking,
      filters: [
        { name: "room", model: models.ShowRoom, text: "room__name" },
        { name: "people", model: models.ShowPerson, text: "person__name" },
        {
          name: "status",
          label: "Stato",
          values: [
            { id: 1, name: "Bloccata" },
            { id: 2, name: "Confermata" },
            { id: 3, name: "Pagata" },
          ],
        },
      ],
    }
  },
  computed: {
    modelFk() {
      return { show: this.$route.params.id }
    },
  },
  methods: {
    defaultItem: () => ({
      room: null,
      people: [],
      start_date: "",
      end_date: "",
      cost: 1,
      kind: 1,
      notes: "",
    }),
    formatDate(date) {
      const parsedDate = new Date(date)
      const day = String(parsedDate.getDate()).padStart(2, '0')
      const month = String(parsedDate.getMonth() + 1).padStart(2, '0')
      const year = parsedDate.getFullYear()
      const hours = String(parsedDate.getHours()).padStart(2, '0')
      const minutes = String(parsedDate.getMinutes()).padStart(2, '0')
      return `${day}/${month}/${year} ${hours}:${minutes}`
    }
  },
}
</script>
